import { render } from "./route-tree-node.vue?vue&type=template&id=66608fe4"
import script from "./route-tree-node.vue?vue&type=script&lang=js"
export * from "./route-tree-node.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__